<template>
  <div class="row">
    <div class="col-10">
      <div class="edit-title-name">
        <i :class="icon" v-if="icon"/>
        <h1>{{title}}</h1>
      </div>
    </div>
    <div class="col-2 rm-p-l">
      <div class="dropdown mobile-menu-dropdown">
        <a :id="'m-medium-'+id" aria-expanded="false" aria-haspopup="true" class="mobile-menu-link"
           data-toggle="dropdown"
           href="javascript:">
          <i class="fal fa-bars"/>
        </a>
        <div :aria-labelledby="'m-medium-'+id" class="dropdown-menu dropdown-menu-right">
          <slot name="menu"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // @vuese
  // @group General/ui
  // Title menu
  export default {
    name: 'TitleMenu',
    props: {
      //@vuese
      // Icon used in the menu
      icon: {
        type: String,
        //@vuese
        // returns empty string if no icon provided
        default: '',
        required: false
      },
      //@vuese
      // title used in the menu
      title: {
        type: String,
        required: true
      },
      //@vuese
      // id used in the menu
      id: {
        type: String,
        // @vuese
        // returns component random id if no id provided
        default: function(){
          return this._uid
        },
        required: false
      }
    }
  };
</script>